import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["agadir-airport-to-imsouane-surf"];

export const Route = createFileRoute("/transfers/agadir-airport-to-imsouane-surf")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
